import { devtoolsExchange } from '@urql/devtools'
import { createClient, dedupExchange, cacheExchange, fetchExchange, ssrExchange } from 'urql'

import { traceExchange, errorExchange } from '../server/helpers/custom-exchanges'
import { env, isDev } from '../server/helpers/env'

import { graphql } from '~/../__config__/urls.json'

const makeClient = ({ isServer, fetch, trace, uscd }) => {
  const isClient = !isServer
  const serverURL = graphql[isServer ? 'server' : 'client'][env]

  // Phase 1: ready the exchanges to pass them through to the clients.
  const ssrCache = ssrExchange({
    initialState: isClient ? window.__initialState__ : null,
    isClient
  })

  const exchanges = isServer
    ? [dedupExchange, traceExchange(trace), ssrCache]
    : [dedupExchange, cacheExchange, ssrCache]

  exchanges.push(errorExchange)
  exchanges.push(fetchExchange)

  // Phase 2: create the fetch options that will be passed to every request.
  const fetchOptions = {
    credentials: 'same-origin',
    headers: { uscd }
  }

  if (isServer) {
    fetchOptions.headers['X-Is-Server'] = 'true'
  }

  // Phase 3: create client
  const client = createClient({
    url: serverURL,
    suspense: isServer,
    fetch,
    fetchOptions,
    requestPolicy: 'cache-first',
    exchanges: isDev ? [devtoolsExchange, ...exchanges] : exchanges
  })

  return [client, ssrCache]
}

export default makeClient
